// extracted by mini-css-extract-plugin
export default {"threadCreateButton":"styles_threadCreateButton__Gky70","fadeIn":"styles_fadeIn__RXLDW"};